module.exports = __webpack_public_path__ + "img/197.913f23d8.jpg";